

import { Box, Paper, PaperProps, Typography } from "@mui/material";
import CustomMDEditor from "../../../components/CustomMD/CustomMDEditor";
import CustomMDPreview from "../../../components/CustomMD/CustomMDPreview";
import { User } from "../../../types/User";
interface EducationProps {
    userData: User;
    setUserData: React.Dispatch<React.SetStateAction<User | null>>;
    editMode: boolean;
    paperProps?: PaperProps;
}

const Education = ({
    userData,
    setUserData,
    editMode,
    paperProps,
}: EducationProps) => {
    const handleDescriptionChange = (value?: string) => {
        setUserData((prevData) => {
            if (!prevData) return null;
            return {
                ...prevData,
                education: value || ""
            };
        });
    };

    return (
        <Paper {...paperProps} sx={{ padding: 2, mb: 3, borderRadius: 2, ...paperProps?.sx }}>
            <Box>
                <Typography variant="h6" mb={3}>
                    Education
                </Typography>
                {editMode ? (
                    <CustomMDEditor
                        value={userData.education || ""}
                        onChange={handleDescriptionChange}
                        placeholder={
                            `Add your education history here`
                        }
                        customStyles={{
                            width: '100%',
                        }}
                    />
                ) : (
                    <CustomMDPreview description={userData.education || "No Education provided yet."} />
                )}
            </Box>
        </Paper>
    );
};

export default Education;
